import script from "./OrdersShow.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrdersShow.vue?vue&type=script&lang=ts&setup=true"

import "./OrdersShow.vue?vue&type=style&index=0&id=8c8d68e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c8d68e0"]])

export default __exports__